import { Directive, signal } from '@angular/core';

/**
 * El «mouse encima» de los campos, como `dx-state-hover` de DevExtreme: se enciende cuando el
 * puntero se mueve sobre el campo (no con el dedo) y se apaga cuando sale. A diferencia de `:hover`
 * (y de `pointerenter`, que Chrome también dispara), no se enciende si el campo aparece bajo un
 * puntero quieto, como al abrir la matriz con un clic (captura IMG082).
 */
@Directive({
  host: {
    '[class.sck-hover]': 'hovered()',
    '(pointermove)': 'move($event)',
    '(pointerleave)': 'hovered.set(false)',
  },
})
export class ScFieldHover {
  protected readonly hovered = signal(false);

  protected move(event: PointerEvent): void {
    if (!this.hovered() && event.pointerType !== 'touch') this.hovered.set(true);
  }
}
